(() => {
    let applyzipfieldcompletion = (selector) => {
        document.querySelectorAll(selector).forEach((field) => {
            field.setAttribute('autocomplete', 'off')

            autocomplete({
                input: field,
                fetch: function (text, update) {
                    text = text.toLowerCase();

                    let queryString = new URLSearchParams({
                        apiKey: 'OA0yIoKX5iUS51kxVMPiklNTh8gVFjhuOq_8ScJjSKQ',
                        in: 'countryCode:DEU',
                        q: text,
                        types: 'postalCode'
                    })

                    let request = new XMLHttpRequest()
                    request.open('GET', 'https://autocomplete.search.hereapi.com/v1/autocomplete?' + queryString, true);

                    request.onload = function () {
                        if (this.status >= 200 && this.status < 400) {
                            // Success!
                            var data = JSON.parse(this.response)
                            update(
                              data.items
                                .map(function(suggestion) {
                                    let label = suggestion.address.postalCode

                                    if (suggestion.address.city) {
                                        label = label + ', ' + suggestion.address.city
                                    }

                                    return {
                                        label: label,
                                        value: suggestion
                                    }
                                })
                            )
                        }
                    };

                    request.onerror = function () {
                        // There was a connection error of some sort
                    };

                    request.send();
                },
                onSelect: function (item) {
                    field.value = item.value.address.postalCode

                    if (!field.closest('form').querySelector('input.cityfieldcompletion')) {
                        return
                    }

                    if (!item.value.address.city) {
                        return
                    }

                    field.closest('form').querySelector('input.cityfieldcompletion').value = item.value.address.city
                },
                className: 'autocomplete-suggestions'
            })
        })
    }

    let applystreetfieldcompletion = (selector) => {
        document.querySelectorAll(selector).forEach((field) => {
            field.setAttribute('autocomplete', 'off')

            autocomplete({
                input: field,
                fetch: function (text, update) {
                    let zip = field.closest('form').querySelector('input.zipfieldcompletion').value

                    if (!zip) {
                        return
                    }

                    let q = zip + ", " + text.toLowerCase()

                    let queryString = new URLSearchParams({
                        apiKey: 'OA0yIoKX5iUS51kxVMPiklNTh8gVFjhuOq_8ScJjSKQ',
                        in: 'countryCode:DEU',
                        q: q
                    })

                    let request = new XMLHttpRequest()
                    request.open('GET', 'https://autocomplete.search.hereapi.com/v1/autocomplete?' + queryString, true);

                    request.onload = function () {
                        if (this.status >= 200 && this.status < 400) {
                            // Success!
                            var data = JSON.parse(this.response)
                            update(
                              data.items
                                .map(function(suggestion) {
                                    let label = suggestion.address.street

                                    return {
                                        label: label,
                                        value: suggestion
                                    }
                                })
                            )
                        }
                    };

                    request.onerror = function () {
                        // There was a connection error of some sort
                    };

                    request.send();
                },
                onSelect: function (item) {
                    field.value = item.value.address.street
                },
                className: 'autocomplete-suggestions'
            })
        })
    }

    window.addEventListener("DOMContentLoaded", () => {
        applyzipfieldcompletion('input.zipfieldcompletion')
        applystreetfieldcompletion('input.streetfieldcompletion')
    })

    window.addEventListener('parcelsRendered', function (e) {
        applyzipfieldcompletion('.tntsignatureform input[type=number]')
    })
}) ()
